import { ServiceValues } from '../values/ServiceValues';
import { ServiceAxios } from './ServiceEW';
import { Values } from '../values/Values';

const timeout = ServiceValues.timeout;
const baseUrl = ServiceValues.base_url_local;

async function getQtdVisitasPorMes() {
  try {
    const api = ServiceAxios(baseUrl, timeout);
    const dados = await api.get('dashboard/qtd-visitas-mensal/');
    if (dados) {
      if (dados.data) {
        return dados.data;
      }
      else {
        return {
          isSuccess: false,
          message: Values.MessageValues.erro_catch,
          result: []
        }
      }
    }
    else {
      return {
        isSuccess: false,
        message: Values.MessageValues.erro_catch,
        result: []
      };
    }
  } catch (e) {
    return {
      isSuccess: false,
      message: Values.MessageValues.erro_catch,
      result: []
    };

  }
}

async function getQtdVisitasGeral() {
  try {
    const api = ServiceAxios(baseUrl, timeout);
    const dados = await api.get('dashboard/qtd-visitas-geral/');
    if (dados) {
      if (dados.data) {
        return dados.data;
      }
      else {
        return {
          isSuccess: false,
          message: Values.MessageValues.erro_catch,
          result: []
        }
      }
    }
    else {
      return {
        isSuccess: false,
        message: Values.MessageValues.erro_catch,
        result: []
      };
    }
  } catch (e) {
    return {
      isSuccess: false,
      message: Values.MessageValues.erro_catch,
      result: []
    };

  }
}

async function getValorVisitasMes() {
  try {
    const api = ServiceAxios(baseUrl, timeout);
    const dados = await api.get('dashboard/valor-visitas-mensal/');
    if (dados) {
      if (dados.data) {
        return dados.data;
      }
      else {
        return {
          isSuccess: false,
          message: Values.MessageValues.erro_catch,
          result: []
        }
      }
    }
    else {
      return {
        isSuccess: false,
        message: Values.MessageValues.erro_catch,
        result: []
      };
    }
  } catch (e) {
    return {
      isSuccess: false,
      message: Values.MessageValues.erro_catch,
      result: []
    };

  }
}

async function getQtdFiliadosGeral() {
  try {
    const api = ServiceAxios(baseUrl, timeout);
    const dados = await api.get('dashboard/qtd-filiados-geral/');
    if (dados) {
      if (dados.data) {
        return dados.data;
      }
      else {
        return {
          isSuccess: false,
          message: Values.MessageValues.erro_catch,
          result: []
        }
      }
    }
    else {
      return {
        isSuccess: false,
        message: Values.MessageValues.erro_catch,
        result: []
      };
    }
  } catch (e) {
    return {
      isSuccess: false,
      message: Values.MessageValues.erro_catch,
      result: []
    };

  }
}

async function getVisitasPorMes(periodo, dataInicial, dataFinal) {
  try {
    const api = ServiceAxios(baseUrl, timeout);
    let params = {
      periodo: periodo,
      dataInicial: dataInicial,
      dataFinal: dataFinal
    }
    const dados = await api.get('dashboard/visitas-por-mes/', { params: params });
    if (dados) {
      if (dados.data) {
        return dados.data;
      }
      else {
        return {
          isSuccess: false,
          message: Values.MessageValues.erro_catch,
          result: []
        }
      }
    }
    else {
      return {
        isSuccess: false,
        message: Values.MessageValues.erro_catch,
        result: []
      };
    }
  } catch (e) {
    return {
      isSuccess: false,
      message: Values.MessageValues.erro_catch,
      result: []
    };

  }
}

async function getModalidadesMaisUsadas() {
  try {
    const api = ServiceAxios(baseUrl, timeout);
    const dados = await api.get('dashboard/modalidades-mais-usadas/');
    if (dados) {
      if (dados.data) {
        return dados.data;
      }
      else {
        return {
          isSuccess: false,
          message: Values.MessageValues.erro_catch,
          result: []
        }
      }
    }
    else {
      return {
        isSuccess: false,
        message: Values.MessageValues.erro_catch,
        result: []
      };
    }
  } catch (e) {
    return {
      isSuccess: false,
      message: Values.MessageValues.erro_catch,
      result: []
    };

  }
}

async function getFiliadosMaisLucrativos() {
  try {
    const api = ServiceAxios(baseUrl, timeout);
    const dados = await api.get('dashboard/filiados-mais-lucrativos/');
    if (dados) {
      if (dados.data) {
        return dados.data;
      }
      else {
        return {
          isSuccess: false,
          message: Values.MessageValues.erro_catch,
          result: []
        }
      }
    }
    else {
      return {
        isSuccess: false,
        message: Values.MessageValues.erro_catch,
        result: []
      };
    }
  } catch (e) {
    return {
      isSuccess: false,
      message: Values.MessageValues.erro_catch,
      result: []
    };

  }
}

async function getInsumosMaisProcurados() {
  try {
    const api = ServiceAxios(baseUrl, timeout);
    const dados = await api.get('dashboard/insumos-mais-procurados/');
    if (dados) {
      if (dados.data) {
        return dados.data;
      }
      else {
        return {
          isSuccess: false,
          message: Values.MessageValues.erro_catch,
          result: []
        }
      }
    }
    else {
      return {
        isSuccess: false,
        message: Values.MessageValues.erro_catch,
        result: []
      };
    }
  } catch (e) {
    return {
      isSuccess: false,
      message: Values.MessageValues.erro_catch,
      result: []
    };

  }
}

async function getDiasSemanaMaisVisitantes() {
  try {
    const api = ServiceAxios(baseUrl, timeout);
    const dados = await api.get('dashboard/dias-semana-mais-visitantes/');
    if (dados) {
      if (dados.data) {
        return dados.data;
      }
      else {
        return {
          isSuccess: false,
          message: Values.MessageValues.erro_catch,
          result: []
        }
      }
    }
    else {
      return {
        isSuccess: false,
        message: Values.MessageValues.erro_catch,
        result: []
      };
    }
  } catch (e) {
    return {
      isSuccess: false,
      message: Values.MessageValues.erro_catch,
      result: []
    };

  }
}

async function getDiasSemanaMaisFiliadoAtivos() {
  try {
    const api = ServiceAxios(baseUrl, timeout);
    const dados = await api.get('dashboard/dias-semana-mais-filiados-ativos/');
    if (dados) {
      if (dados.data) {
        return dados.data;
      }
      else {
        return {
          isSuccess: false,
          message: Values.MessageValues.erro_catch,
          result: []
        }
      }
    }
    else {
      return {
        isSuccess: false,
        message: Values.MessageValues.erro_catch,
        result: []
      };
    }
  } catch (e) {
    return {
      isSuccess: false,
      message: Values.MessageValues.erro_catch,
      result: []
    };

  }
}

async function getPerdasInsumos(dataInicial, dataFinal) {
  try {
    let params = {
      dataInicial: dataInicial,
      dataFinal: dataFinal
    };
    const api = ServiceAxios(baseUrl, timeout);
    const dados = await api.get('dashboard/perdas-insumos/', { params: params });
    if (dados) {
      if (dados.data) {
        return dados.data;
      }
      else {
        return {
          isSuccess: false,
          message: Values.MessageValues.erro_catch,
          result: []
        }
      }
    }
    else {
      return {
        isSuccess: false,
        message: Values.MessageValues.erro_catch,
        result: []
      };
    }
  } catch (e) {
    return {
      isSuccess: false,
      message: Values.MessageValues.erro_catch,
      result: []
    };

  }
}

async function getInsumosMaisUsados() {
  try {
    const api = ServiceAxios(baseUrl, timeout);
    const dados = await api.get('dashboard/insumos-mais-usados/');
    if (dados) {
      if (dados.data) {
        return dados.data;
      }
      else {
        return {
          isSuccess: false,
          message: Values.MessageValues.erro_catch,
          result: []
        }
      }
    }
    else {
      return {
        isSuccess: false,
        message: Values.MessageValues.erro_catch,
        result: []
      };
    }
  } catch (e) {
    return {
      isSuccess: false,
      message: Values.MessageValues.erro_catch,
      result: []
    };

  }
}

export {
  getQtdVisitasPorMes,
  getQtdVisitasGeral,
  getValorVisitasMes,
  getQtdFiliadosGeral,
  getVisitasPorMes,
  getModalidadesMaisUsadas,
  getFiliadosMaisLucrativos,
  getInsumosMaisProcurados,
  getDiasSemanaMaisVisitantes,
  getDiasSemanaMaisFiliadoAtivos,
  getInsumosMaisUsados,
  getPerdasInsumos
};
